import React from 'react';
import {Button, Grid, Typography, withStyles} from "material-ui";
import {Link} from "react-router-dom";

import List from './../../assets/icons/lists.svg';
import Warning from './../../assets/icons/warning.svg';
import Flats from './../../assets/icons/flats.svg';
import Graph from './../../assets/icons/graph.svg';
import Users from './../../assets/icons/users.svg';
import Employees from './../../assets/icons/employees.svg';
import {connect} from "react-redux";

export class DashBoardContainer extends React.Component {

    componentDidMount = () => {
        document.title = 'ダッシュボード | 三島事務所';
    };

    render() {

        const {classes, currentUser} = this.props;

        return (
            <div className={classes.root}>

                <Grid container>
                    <Grid item xs={6} md={3} lg={2}>
                        <div>
                            <Button className={classes.item}
                                    disableRipple
                                    component={Link}
                                    to={'/regulation'}>

                                <img src={List} className={classes.icon} alt="法令チェック"/>
                                <Typography type="subheading">法令チェック</Typography>
                                <Typography className={classes.description}>顧客の追加、課題の管理を行います</Typography>
                            </Button>
                        </div>
                    </Grid>

                    <Grid item xs={6} md={3} lg={2}>
                        <div>
                            <Button className={classes.item}
                                    disableRipple
                                    component={Link}
                                    to={'/task'}>
                                <img src={Warning} className={classes.icon} alt="課題"/>
                                <Typography type="subheading">課題</Typography>
                                <Typography className={classes.description}>課題の追加や編集など、課題に関する管理</Typography>
                            </Button>
                        </div>
                    </Grid>

                    <Grid item xs={6} md={3} lg={2}>
                        <div>
                            <Button className={classes.item}
                                    disableRipple
                                    component={Link}
                                    to={'/company'}>

                                <img src={Flats} className={classes.icon} alt="会社プロフィール"/>
                                <Typography type="subheading">会社プロフィール</Typography>
                                <Typography className={classes.description}>所在地や資本金、会社情報に関する設定</Typography>
                            </Button>
                        </div>
                    </Grid>

                    <Grid item xs={6} md={3} lg={2}>
                        <div>
                            <Button className={classes.item}
                                    disableRipple
                                    component={Link}
                                    to={'/user'}>

                                <img src={Employees} className={classes.icon} alt="ユーザー"/>
                                <Typography type="subheading">ユーザー</Typography>
                                <Typography className={classes.description}>ユーザーの追加、名前の変更、管理を行います</Typography>
                            </Button>
                        </div>
                    </Grid>

                    {currentUser.is_admin ?
                        <Grid item xs={6} md={3} lg={2}>

                            <div>
                                <Button className={classes.item}
                                        disableRipple
                                        component={Link}
                                        to={'/client'}>

                                    <img src={Users} className={classes.icon} alt="顧客管理"/>
                                    <Typography type="subheading">顧客管理</Typography>
                                    <Typography className={classes.description}>顧客情報の登録や編集などの管理</Typography>
                                </Button>
                            </div>
                        </Grid>
                        : null}

                    <Grid item xs={6} md={3} lg={2}>
                        <div>
                            <Button className={classes.item}
                                    disableRipple
                                    component={Link}
                                    to={'/report'}>

                                <img src={Graph} className={classes.icon} alt="レポート"/>
                                <Typography type="subheading">レポート</Typography>
                                <Typography className={classes.description}>法令チェックや課題に関するレポート</Typography>
                            </Button>
                        </div>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

const styles = theme => ({
    root: {
        padding: theme.spacing.unit * 3,
    },
    item: {
        textAlign: 'center',
        display: 'block',
        margin: 'auto',
        paddingTop: '24px',
        paddingBottom: '24px',
    },
    icon: {
        margin: 10,
        width: 60,
        height: 60,
    },
    description: {
        paddingTop: 5,
        fontSize: '.8em',
    }
});

DashBoardContainer = withStyles(styles)(DashBoardContainer);

DashBoardContainer = connect(
    (state) => {
        return {
            currentUser: state.users.currentUser
        }
    }
)(DashBoardContainer);


// WEBPACK FOOTER //
// ./src/containers/dashboard/index.js